module.exports = __webpack_public_path__ + "img/GBP.a61dd07f.svg";